import { ChevronRight } from "lucide-react";
import { NavLink } from "react-router-dom";
import type { NavItem } from "@/lib/nav";
import { NavBadge } from "@/navigation/NavBadge";
import { NavIcon } from "@/navigation/NavIcon";
import { useNav } from "@/navigation/navContext";
import { classNames } from "@/lib/format";

interface StammdatenNavTileProps {
  item: NavItem;
}

export function StammdatenNavTile({ item }: StammdatenNavTileProps) {
  const { badges } = useNav();

  return (
    <NavLink
      to={item.href}
      className={({ isActive }) =>
        classNames(
          "group relative flex min-h-[6.5rem] flex-col rounded-2xl border p-4 transition-all duration-200 active:scale-[0.99]",
          isActive
            ? "border-accent/35 bg-accent-soft text-accent"
            : "border-separator bg-card text-label hover:border-accent/30 hover:bg-fill-quaternary hover:shadow-sm",
        )
      }
    >
      <div className="flex items-start justify-between gap-2">
        {item.icon ? (
          <span
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-soft text-accent transition-transform duration-200 group-hover:scale-105"
            aria-hidden
          >
            <NavIcon name={item.icon} size={20} />
          </span>
        ) : (
          <span />
        )}
        <NavBadge item={item} badges={badges} />
      </div>
      <span className="mt-3 text-sm font-semibold leading-tight">{item.label}</span>
      {item.description ? (
        <span className="mt-1 line-clamp-2 text-xs leading-snug text-label-secondary">
          {item.description}
        </span>
      ) : null}
      <ChevronRight
        size={16}
        className="absolute bottom-4 right-4 text-label-tertiary opacity-0 transition-opacity group-hover:opacity-100"
        aria-hidden
      />
    </NavLink>
  );
}
